module.exports = __webpack_public_path__ + "static/media/spritesv3.617ae842.png";